import { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import { useParams } from 'react-router-dom';
// Types
import IPage from 'models/Page';
// Components
import Accordion from 'components/Accordion';
import WaitingForm from './WaitingForm';
// i18next
import { useTranslation } from 'react-i18next';

type Props = {
  waitingRef: string;
  defaultExpanded?: boolean;
}

const Waiting: FC<Props> = ({ waitingRef, defaultExpanded }) => {
  const { t } = useTranslation();

  const { quizId } = useParams<{ quizId: string }>();
  const { watch } = useFormContext();

  const watchedPages = watch('pages');
  const pageRef = watchedPages.find((page: IPage) => page.refs.includes(waitingRef))?.uuid;

  return (
    <div>
      <Accordion
        label={`${t('labels.waiting')} ${t('labels.page')}`} icon="hour_glass"
        previewPage="waiting" previewPageRef={pageRef}
        defaultExpanded={defaultExpanded}
      >
        <WaitingForm waitingRef={waitingRef} quizId={quizId} />
      </Accordion>
    </div>
  );
};

export default Waiting;
